module.exports = __webpack_public_path__ + "img/0-13.120d2510.gif";